<template>
    <div>
        <div>
            <div class="main-wrapper">
                <div>
                    <layout-header></layout-header>
                    <breadcrumb66></breadcrumb66>

                    <!-- Page Content -->
                    <div class="content">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                    <sidebar></sidebar>
                                </div>

                                <div class="col-md-5 col-lg-6 col-xl-7" v-if="showspinner">
                                    <loader></loader>
                                </div>

                                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                                    <div class="card ml-md-4" id="shedule_container" style="border: none;">
                                        <div class="header row">
                                            <div class="col-md-4 mb-2">
                                                <div class="input-group">
                                                    <label for="referral" style="font-size: 12px;">My Referral Mobile No.</label>
                                                    <input type="text" id="referral" v-model="referralNumber" placeholder="Enter Mobile No." style="font-size: 12px;" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="checkbox-group">
                                                    <input type="checkbox" id="physiotherapist" v-model="isPhysiotherapist" />
                                                    <label for="physiotherapist" style="font-size: 12px;">Physiotherapist</label>
                                                    <input type="checkbox" id="patient" v-model="isPatient" style="margin-left: 10px;" />
                                                    <label for="patient" style="font-size: 12px;">Patient</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="whatsapp-share">
                                                    <span style="font-size: 12px;">Share via WhatsApp to your Referral&nbsp;</span>
                                                    <i class="fab fa-whatsapp" style="color:#2E8B57; font-size: 25px;"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="cards-container">
                                            <div v-for="(card, index) in cards" :key="index" class="card">
                                                <div class="card-header">{{ card.name }}</div>
                                                <div class="card-body">
                                                    <div>DOJ – {{ card.doj }}</div>
                                                    <div class="points">{{ card.points }}</div>
                                                    <div>Points Earned</div>
                                                </div>
                                                <div class="card-footer"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Content -->
                    <layout-footer></layout-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            referralNumber: '',
            isPhysiotherapist: false,
            isPatient: false,
            cards: [
                { name: 'Piyush Mantry', doj: '03 Sep 2024', points: 10 },
                { name: 'Piyush Mantry', doj: '03 Sep 2024', points: 10 },
                { name: 'Piyush Mantry', doj: '03 Sep 2024', points: 10 },
            ],
        };
    },
};
</script>

<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.header input[type="text"] {
    padding: 10px;
    width: 100%;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
}

.card {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    position: relative;
}

.card-header {
    background-color: #1a3e92;
    color: white;
    padding: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-weight: bold;
    font-size: 16px;
}

.card-body {
    margin: 10px 0;
    font-size: 14px;
}

.card-body .points {
    font-size: 36px;
    font-weight: bold;
    margin: 10px 0;
}

.card-footer {
    position: absolute;
    bottom: 10px;
    right: 10px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .header {
        flex-direction: column;
        align-items: flex-start;
    }

    .header .whatsapp-share {
        margin-top: 10px;
    }

    .cards-container {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }
}

@media (max-width: 576px) {
    .header .input-group,
    .header .checkbox-group,
    .header .whatsapp-share {
        width: 100%;
    }

    .header input[type="text"] {
        width: 100%;
    }

    .cards-container {
        grid-template-columns: 1fr;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Referal.vue